import * as yup from 'yup';

export const emailOptionalValidator = () =>
	yup.string().trim().email('email.valid').max(254, 'email.length');

export const emailRequiredValidator = () =>
	emailOptionalValidator().required('email.required');
